module.exports = __webpack_public_path__ + "static/media/tick.28e6635e.mp3";